export const iprPreference = [
  { label: "Allowed", value: "1" },
  { label: "Minimum", value: "2" },
  { label: "No IPR", value: "0" },
];
